/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 scene.gltf --transform
Author: Amine GND (https://sketchfab.com/amineguendouzi48)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/alienware-m18-gaming-laptop-164b178aac4940be9321c85532ede60e
Title: Alienware m18 Gaming Laptop
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, OrbitControls, Html } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import KeyControls from "./KeyControls"; // Import the KeyControls component

export default function Model(props) {
  const { nodes, materials } = useGLTF(
    "/models/alienware/scene-transformed.glb"
  );

  const meshRef = useRef();
  const originalPosition = useRef(new THREE.Vector3(0, 0, 0)); // Store the original position

  // Set initial position or other properties for the mesh
  useEffect(() => {
    if (meshRef.current) {
      meshRef.current.position.copy(originalPosition.current);
    }
  }, []);

  return (
    <group {...props} dispose={null}>
      <group position={[-0.02, 0.3, -0.09]} rotation={[Math.PI / 2, 0, 0]}>
        <Html
          transform
          wrapperClass="htmlScreen"
          distanceFactor={1.17}
          position={[0, 0, -1.4]}
          rotation-x={300}
        >
          <h1>Hemmp</h1>
          <iframe src="https://bieke-portfolio-n3ql.onrender.com/" />
        </Html>
        <mesh
          geometry={nodes.Object_258.geometry}
          material={materials.Material}
        />
        <mesh
          geometry={nodes.Object_259.geometry}
          material={materials["Material.009"]}
        />
        <mesh
          geometry={nodes.Object_260.geometry}
          material={materials["Material.006"]}
        />
        <mesh
          geometry={nodes.Object_261.geometry}
          material={materials["Material.001"]}
        />
        <mesh
          geometry={nodes.Object_262.geometry}
          material={materials["Material.004"]}
        />
      </group>
      <mesh
        geometry={nodes.Object_4.geometry}
        material={materials["Material.005"]}
        position={[0.87, 0.33, 0.87]}
      />
      <mesh
        geometry={nodes.Object_6.geometry}
        material={materials["Material.005"]}
        position={[-1.62, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_8.geometry}
        material={materials["Material.005"]}
        position={[-1.62, 0.33, 0.95]}
      />
      <mesh
        geometry={nodes.Object_10.geometry}
        material={materials["Material.005"]}
        position={[-1.43, 0.33, 0.93]}
      />
      <mesh
        geometry={nodes.Object_12.geometry}
        material={materials["Material.005"]}
        position={[-1.23, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_14.geometry}
        material={materials["Material.005"]}
        position={[-1.05, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_16.geometry}
        material={materials["Material.005"]}
        position={[-0.86, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_18.geometry}
        material={materials["Material.005"]}
        position={[-0.66, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_20.geometry}
        material={materials["Material.005"]}
        position={[-0.47, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_22.geometry}
        material={materials["Material.005"]}
        position={[-0.26, 0.33, 0.95]}
      />
      <mesh
        geometry={nodes.Object_24.geometry}
        material={materials["Material.005"]}
        position={[-0.06, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_26.geometry}
        material={materials["Material.005"]}
        position={[0.13, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_28.geometry}
        material={materials["Material.005"]}
        position={[0.33, 0.33, 0.92]}
      />
      <mesh
        geometry={nodes.Object_30.geometry}
        material={materials["Material.005"]}
        position={[0.33, 0.33, 0.84]}
      />
      <mesh
        geometry={nodes.Object_32.geometry}
        material={materials["Material.005"]}
        position={[0.52, 0.33, 0.94]}
      />
      <mesh
        geometry={nodes.Object_34.geometry}
        material={materials["Material.005"]}
        position={[0.52, 0.33, 0.88]}
      />
      {/* Q */}
      <group ref={meshRef}>
        <KeyControls meshRef={meshRef} />

        <mesh
          geometry={nodes.Object_36.geometry}
          material={materials["Material.005"]}
          position={[-1.53, 0.33, 1.08]}
        />
      </group>
      
      <mesh
        geometry={nodes.Object_38.geometry}
        material={materials["Material.005"]}
        position={[-1.34, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_40.geometry}
        material={materials["Material.005"]}
        position={[-1.14, 0.33, 1.08]}
      />
      {/* r */}
      <mesh
        geometry={nodes.Object_42.geometry}
        material={materials["Material.005"]}
        position={[-0.94, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_44.geometry}
        material={materials["Material.005"]}
        position={[-0.74, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_46.geometry}
        material={materials["Material.005"]}
        position={[-0.55, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_48.geometry}
        material={materials["Material.005"]}
        position={[-0.35, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_50.geometry}
        material={materials["Material.005"]}
        position={[-0.14, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_52.geometry}
        material={materials["Material.005"]}
        position={[0.04, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_54.geometry}
        material={materials["Material.005"]}
        position={[0.24, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_56.geometry}
        material={materials["Material.005"]}
        position={[0.45, 0.33, 1.07]}
      />
      <mesh
        geometry={nodes.Object_58.geometry}
        material={materials["Material.005"]}
        position={[0.45, 0.33, 1.14]}
      />
      <mesh
        geometry={nodes.Object_60.geometry}
        material={materials["Material.005"]}
        position={[0.65, 0.33, 1.14]}
      />
      <mesh
        geometry={nodes.Object_62.geometry}
        material={materials["Material.005"]}
        position={[0.65, 0.33, 1.07]}
      />
      <mesh
        geometry={nodes.Object_64.geometry}
        material={materials["Material.005"]}
        position={[0.9, 0.33, 1.08]}
        rotation={[0, 0.22, 0]}
      />
      <mesh
        geometry={nodes.Object_66.geometry}
        material={materials["Material.005"]}
        position={[0.89, 0.33, 1.14]}
        rotation={[0, -0.27, 0]}
      />
      <mesh
        geometry={nodes.Object_68.geometry}
        material={materials["Material.005"]}
        position={[1.1, 0.33, 1.14]}
      />
      <mesh
        geometry={nodes.Object_70.geometry}
        material={materials["Material.005"]}
        position={[1.13, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_72.geometry}
        material={materials["Material.005"]}
        position={[1.32, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_74.geometry}
        material={materials["Material.005"]}
        position={[1.52, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_76.geometry}
        material={materials["Material.005"]}
        position={[1.31, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_78.geometry}
        material={materials["Material.005"]}
        position={[1.5, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_80.geometry}
        material={materials["Material.005"]}
        position={[1.7, 0.33, 0.86]}
      />
      <mesh
        geometry={nodes.Object_82.geometry}
        material={materials["Material.005"]}
        position={[1.49, 0.33, 1.14]}
      />
      <mesh
        geometry={nodes.Object_84.geometry}
        material={materials["Material.005"]}
        position={[1.7, 0.33, 1.15]}
      />
      <mesh
        geometry={nodes.Object_86.geometry}
        material={materials["Material.005"]}
        position={[1.13, 0.33, 1.28]}
      />
      <mesh
        geometry={nodes.Object_88.geometry}
        material={materials["Material.005"]}
        position={[1.32, 0.33, 1.28]}
      />
      <mesh
        geometry={nodes.Object_90.geometry}
        material={materials["Material.005"]}
        position={[1.52, 0.33, 1.28]}
      />
      <mesh
        geometry={nodes.Object_92.geometry}
        material={materials["Material.005"]}
        position={[1.13, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_94.geometry}
        material={materials["Material.005"]}
        position={[1.32, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_96.geometry}
        material={materials["Material.005"]}
        position={[1.52, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_98.geometry}
        material={materials["Material.005"]}
        position={[1.11, 0.33, 1.54]}
      />
      <mesh
        geometry={nodes.Object_100.geometry}
        material={materials["Material.005"]}
        position={[1.49, 0.33, 1.54]}
      />
      <mesh
        geometry={nodes.Object_102.geometry}
        material={materials["Material.005"]}
        position={[1.68, 0.33, 1.54]}
      />
      <mesh
        geometry={nodes.Object_104.geometry}
        material={materials["Material.005"]}
        position={[1.32, 0.33, 1.68]}
      />
      <mesh
        geometry={nodes.Object_106.geometry}
        material={materials["Material.005"]}
        position={[1.31, 0.33, 1.75]}
      />
      <mesh
        geometry={nodes.Object_108.geometry}
        material={materials["Material.005"]}
        position={[1.5, 0.33, 1.75]}
      />
      <mesh
        geometry={nodes.Object_110.geometry}
        material={materials["Material.005"]}
        position={[1.53, 0.33, 1.67]}
      />
      <mesh
        geometry={nodes.Object_112.geometry}
        material={materials["Material.005"]}
        position={[-1.78, 0.33, 1.08]}
      />
      <mesh
        geometry={nodes.Object_114.geometry}
        material={materials["Material.005"]}
        position={[-1.77, 0.33, 1.28]}
      />
      <mesh
        geometry={nodes.Object_116.geometry}
        material={materials["Material.005"]}
        position={[-1.72, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_118.geometry}
        material={materials["Material.005"]}
        position={[-1.82, 0.33, 1.69]}
      />
      <mesh
        geometry={nodes.Object_120.geometry}
        material={materials["Material.005"]}
        position={[-1.58, 0.33, 1.67]}
      />
      <mesh
        geometry={nodes.Object_122.geometry}
        material={materials["Material.005"]}
        position={[-1.19, 0.33, 1.67]}
      />
      <mesh
        geometry={nodes.Object_124.geometry}
        material={materials["Material.005"]}
        position={[-1.48, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_126.geometry}
        material={materials["Material.005"]}
        position={[-1.28, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_128.geometry}
        material={materials["Material.005"]}
        position={[-1.09, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_130.geometry}
        material={materials["Material.005"]}
        position={[-0.89, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_132.geometry}
        material={materials["Material.005"]}
        position={[-0.7, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_134.geometry}
        material={materials["Material.005"]}
        position={[-0.5, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_136.geometry}
        material={materials["Material.005"]}
        position={[-0.29, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_138.geometry}
        material={materials["Material.005"]}
        position={[-0.11, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_140.geometry}
        material={materials["Material.005"]}
        position={[0.09, 0.33, 1.29]}
      />
      <mesh
        geometry={nodes.Object_142.geometry}
        material={materials["Material.005"]}
        position={[0.3, 0.33, 1.27]}
      />
      <mesh
        geometry={nodes.Object_144.geometry}
        material={materials["Material.005"]}
        position={[0.3, 0.33, 1.33]}
      />
      <mesh
        geometry={nodes.Object_146.geometry}
        material={materials["Material.005"]}
        position={[0.49, 0.33, 1.35]}
      />
      <mesh
        geometry={nodes.Object_148.geometry}
        material={materials["Material.005"]}
        position={[0.49, 0.33, 1.3]}
      />
      <mesh
        geometry={nodes.Object_150.geometry}
        material={materials["Material.005"]}
        position={[-1.82, 0.33, 0.89]}
      />
      <mesh
        geometry={nodes.Object_152.geometry}
        material={materials["Material.005"]}
        position={[-1.38, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_154.geometry}
        material={materials["Material.005"]}
        position={[-1.18, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_156.geometry}
        material={materials["Material.005"]}
        position={[-0.99, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_158.geometry}
        material={materials["Material.005"]}
        position={[-0.79, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_160.geometry}
        material={materials["Material.005"]}
        position={[-0.59, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_162.geometry}
        material={materials["Material.005"]}
        position={[-0.4, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_164.geometry}
        material={materials["Material.005"]}
        position={[-0.21, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_166.geometry}
        material={materials["Material.005"]}
        position={[0, 0.33, 1.55]}
      />
      <mesh
        geometry={nodes.Object_168.geometry}
        material={materials["Material.005"]}
        position={[0.19, 0.33, 1.55]}
      />
      <mesh
        geometry={nodes.Object_170.geometry}
        material={materials["Material.005"]}
        position={[0.2, 0.33, 1.47]}
      />
      <mesh
        geometry={nodes.Object_172.geometry}
        material={materials["Material.005"]}
        position={[-0.01, 0.33, 1.67]}
      />
      <mesh
        geometry={nodes.Object_174.geometry}
        material={materials["Material.005"]}
        position={[0.44, 0.33, 1.69]}
      />
      <mesh
        geometry={nodes.Object_176.geometry}
        material={materials["Material.005"]}
        position={[0.63, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_178.geometry}
        material={materials["Material.005"]}
        position={[0.38, 0.33, 1.48]}
      />
      <mesh
        geometry={nodes.Object_180.geometry}
        material={materials["Material.005"]}
        position={[0.38, 0.33, 1.54]}
      />
      <mesh
        geometry={nodes.Object_182.geometry}
        material={materials["Material.005"]}
        position={[0.91, 0.33, 1.5]}
      />
      <mesh
        geometry={nodes.Object_184.geometry}
        material={materials["Material.005"]}
        position={[0.91, 0.33, 1.7]}
      />
      <mesh
        geometry={nodes.Object_186.geometry}
        material={materials["Material.005"]}
        position={[-1.84, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_188.geometry}
        material={materials["Material.005"]}
        position={[-1.63, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_190.geometry}
        material={materials["Material.005"]}
        position={[-1.45, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_192.geometry}
        material={materials["Material.005"]}
        position={[-1.27, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_194.geometry}
        material={materials["Material.005"]}
        position={[-1.09, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_196.geometry}
        material={materials["Material.005"]}
        position={[-0.9, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_198.geometry}
        material={materials["Material.005"]}
        position={[-0.72, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_200.geometry}
        material={materials["Material.005"]}
        position={[-0.54, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_202.geometry}
        material={materials["Material.005"]}
        position={[-0.36, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_204.geometry}
        material={materials["Material.005"]}
        position={[-0.17, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_206.geometry}
        material={materials["Material.005"]}
        position={[0, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_208.geometry}
        material={materials["Material.005"]}
        position={[0.19, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_210.geometry}
        material={materials["Material.005"]}
        position={[0.37, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_212.geometry}
        material={materials["Material.005"]}
        position={[0.53, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_214.geometry}
        material={materials["Material.005"]}
        position={[0.73, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_216.geometry}
        material={materials["Material.005"]}
        position={[0.92, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_218.geometry}
        material={materials["Material.005"]}
        position={[1.15, 0.33, 0.72]}
      />
      <mesh
        geometry={nodes.Object_220.geometry}
        material={materials["Material.005"]}
        position={[1.35, 0.33, 0.72]}
        rotation={[0, 0.03, 0]}
      />
      <mesh
        geometry={nodes.Object_222.geometry}
        material={materials["Material.005"]}
        position={[1.54, 0.33, 0.72]}
        rotation={[0, 0.03, 0]}
      />
      <mesh
        geometry={nodes.Object_224.geometry}
        material={materials["Material.005"]}
        position={[1.54, 0.33, 0.72]}
        rotation={[0, 0.03, 0]}
      />
      <mesh
        geometry={nodes.Object_226.geometry}
        material={materials["Material.005"]}
        position={[1.55, 0.33, 0.72]}
        rotation={[0, 0.03, 0]}
      />
      <mesh
        geometry={nodes.Object_228.geometry}
        material={materials["Material.005"]}
        position={[1.7, 0.33, 0.7]}
      />
      <mesh
        geometry={nodes.Object_230.geometry}
        material={materials["Material.005"]}
        position={[1.1, 0.33, 0.86]}
      />
      <mesh
        geometry={nodes.Object_232.geometry}
        material={materials["Material.005"]}
        position={[-1.43, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_234.geometry}
        material={materials["Material.005"]}
        position={[-1.24, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_236.geometry}
        material={materials["Material.005"]}
        position={[-1.04, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_238.geometry}
        material={materials["Material.005"]}
        position={[-0.84, 0.33, 0.88]}
      />
      {/* //nderkant*/}
      <mesh
        geometry={nodes.Object_240.geometry}
        material={materials["Material.005"]}
        position={[-0.65, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_242.geometry}
        material={materials["Material.005"]}
        position={[-0.44, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_244.geometry}
        material={materials["Material.005"]}
        position={[-0.25, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_246.geometry}
        material={materials["Material.005"]}
        position={[-0.05, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_248.geometry}
        material={materials["Material.005"]}
        position={[0.14, 0.33, 0.88]}
      />
      <mesh
        geometry={nodes.Object_250.geometry}
        material={materials["Material.003"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_252.geometry}
        material={materials["Material.003"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_254.geometry}
        material={materials["Material.003"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_256.geometry}
        material={materials["Material.001"]}
        position={[-0.01, 0.23, -0.42]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Object_264.geometry}
        material={materials["Material.001"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_266.geometry}
        material={materials.Material}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_268.geometry}
        material={materials["Material.006"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Object_270.geometry}
        material={materials["Material.006"]}
        position={[0, 0.22, -0.47]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
    </group>
  );
}

useGLTF.preload("/models/alienware/scene-transformed.glb");
